import { Button, ButtonProps } from '@mui/material'
import React from 'react'

const PlusButton: React.FC<ButtonProps> = (props) => {
    return (
        <Button
            {...props}
            style={{
                maxWidth: '20px',
                maxHeight: '20px',
                minWidth: '20px',
                minHeight: '20px',
                padding: '0px',
                boxShadow: 'none',
                marginRight: '2px',
            }}
            variant='contained'
        >
            +
        </Button>
    )
}

export default PlusButton
